import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { CardController } from 'src/app/shared/card.controller';
import { RegionEditorController } from '../../../regions/parts/region-editor.controller';
import { MarketEditorController } from '../../../market/parts/market-editor.controller';
import { LanguageEditorController } from '../../../language/parts/language-editor.controller';
import { BrandEditorController } from '../../../brands/parts/brand-editor.controller';
import { BooleanView } from 'src/core/ui/boolean.view';

interface Props extends ComponentViewProps<UserItem> {
	mode: ControlMode;
}

@observer
export class UserSettingsView extends React.Component<Props, {}>{
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		return (
			<CardController
				className="card-borderless"
				mode={this.props.mode}
				icon="fa fa-sliders"
				title="User system configuration">
				<Row gutter={16}>
					<Col xs={24} lg={12}>
						<LanguageEditorController
							label="Default Language"
							mode={this.props.mode}
							required
							value={this.props.model.dynamicProperties['language']}
							setBusy={this.props.setBusy}
							onChanged={(newval) => { this.props.model.dynamicProperties['language'] = newval; }}
							onGetErrorMessage={() => this.props.model.validate(true, 'language')}
						/>
					</Col>
					<Col xs={24} lg={12}>
						<RegionEditorController
							label="Default Destiny"
							mode={this.props.mode}
							value={this.props.model.dynamicProperties['defaultDestiny']}
							setBusy={this.props.setBusy}
							onChanged={(newval) => { this.props.model.dynamicProperties["defaultDestiny"] = newval != null ? newval.id : null; }}
							onGetErrorMessage={() => this.props.model.validate(true, 'defaultDestiny')}
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} lg={12}>
						<MarketEditorController
							label="Default Market"
							mode={this.props.mode}
							value={this.props.model.dynamicProperties['defaultMarket']}
							setBusy={this.props.setBusy}
							onChanged={(newval) => { this.props.model.dynamicProperties['defaultMarket'] = newval != null ? newval.id : null; }}
							onGetErrorMessage={() => this.props.model.validate(true, 'defaultMarket')}
						/>
					</Col>
					<Col xs={24} lg={12}>
						<BrandEditorController
							label="Default Brand"
							mode={this.props.mode}
							value={this.props.model.dynamicProperties['defaultBrand']}
							setBusy={this.props.setBusy}
							onChanged={(newval) => { this.props.model.dynamicProperties['defaultBrand'] = newval != null ? newval.id : null }}
							onGetErrorMessage={() => this.props.model.validate(true, 'defaultBrand')}
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24}>
						<BooleanView
							label="Receive tasks notifications"
							mode={this.props.mode}
							value={this.props.model.dynamicProperties["receiveTaskNotifications"]}
							onChanged={e => {
								this.props.model.dynamicProperties["receiveTaskNotifications"] = e;
							}}
						/>
					</Col>
				</Row>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/form/parts/usersettings-form.view.tsx